// extracted by mini-css-extract-plugin
module.exports = {"container":"allMovieSection_container__K_EGr","error":"allMovieSection_error__2JJa0"};